import { render, staticRenderFns } from "./MessageListView.vue?vue&type=template&id=81dcbdaa&scoped=true"
import script from "./MessageListView.vue?vue&type=script&lang=js"
export * from "./MessageListView.vue?vue&type=script&lang=js"
import style0 from "./MessageListView.vue?vue&type=style&index=0&id=81dcbdaa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dcbdaa",
  null
  
)

export default component.exports